import { useState, useEffect } from "react";
import { REACT_APP_API_BASE_URL } from "../../apiurl";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPermissions } from "../../store/slices/permissionsSlice";

// SmartAPI OAuth config
const apiKey = "VbBjrdQN";
const stateVariable = "statevariable";
const redirectUrl = "https://inrise.in/auth/callback";
const smartApiUrl = `https://smartapi.angelone.in/publisher-login?api_key=${apiKey}&state=${stateVariable}&redirect_url=${encodeURIComponent(
  redirectUrl
)}`;



export default function SmartAPILogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [loginStep, setLoginStep] = useState("phone");
  const [status, setStatus] = useState("");

  // ✅ Automatically redirect if session is still active
  useEffect(() => {
    const sessionData = JSON.parse(localStorage.getItem("userSession"));
    if (sessionData && sessionData.expiry > Date.now()) {
      window.location.href = "/home";
    }
  }, []);

  // 📱 SmartAPI popup login
  const handleAngelLogin = () => {
    const popup = window.open(
      smartApiUrl,
      "SmartAPI Login",
      "width=600,height=700,scrollbars=yes"
    );

    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      setStatus("Popup blocked. Please allow popups.");
      return;
    }

    const checkPopup = setInterval(() => {
      if (popup.closed) clearInterval(checkPopup);
    }, 500);
  };


  // 🔑 Step 1: Verify phone number
  const handlePhoneLogin = async (e) => {
    e.preventDefault();
    // if (!agreeToTerms) {
    //   alert("Please accept the Terms & Conditions to proceed.");
    //   return;
    // }
    if (!/^\d{10}$/.test(phoneNumber)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }

    setStatus("Please wait...");
    try {
      // const response = await fetch(`${REACT_APP_API_BASE_URL}api/check-user`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ phone: phoneNumber }),
      // });
      
      const response = await api.post("/check-user/admin-user", { phone: phoneNumber })
      
      const data = await response.data;

      if (!response.status) throw new Error(data.error || "Failed to verify phone");

      if (data?.exists) {
        localStorage.setItem("userId", data.userId);
        setLoginStep("password");
      } else {
        setStatus("No account found. Please sign up first.");
      }
    } catch (error) {
      if (error.status === 403 || error.status === 400) {
        toast.error(error.message);
        // setStatus("Error: " + error.message);
        setTimeout(() => setStatus(""), 3000);
        return;
      }

      toast.error(error.message || "Something went wrong. Please try again.");

      // console.error("Error:", error);

    }
  };

  // 🔒 Step 2: Password verification + session creation
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post('/check-user/verify-password', {
        phoneNumber,
        password
      });

      // 🔍 backend business validation
      if (res.data?.status === false) {
        toast.error(res.data.message || "Password incorrect");
        return;
      }

      // ✅ Create 30-minute session
      const expiryTime = Date.now() + 30 * 60 * 1000;

      const sessionData = {
        phone: phoneNumber,
        loginTime: new Date().toISOString(),
        expiry: expiryTime,
      };

      localStorage.setItem("userSession", JSON.stringify(sessionData));

      toast.success("Login Successful")
           navigate("/home");

    } catch (error) {
      toast.error(error.message || "Something went wrong. Please try again.");
    }

  };


  const goBackToPhone = () => {
    setLoginStep("phone");
    setPassword("");
  };

  // 🎨 Inline Styles
  const styles = {
    container: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    },
    wrapper: { width: "100%", maxWidth: "400px" },
    card: {
      background: "white",
      borderRadius: "16px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      overflow: "hidden",
    },
    header: {
      background: "#141D2F",
      padding: "24px",
      color: "white",
      textAlign: "center",
    },
    title: { fontSize: "24px", fontWeight: "bold", margin: 0 },
    content: { padding: "32px" },
    input: {
      width: "100%",
      padding: "14px",
      border: "1px solid #cbd5e1",
      borderRadius: "10px",
      fontSize: "18px",
      marginBottom: "24px",
      textAlign: "center",
      letterSpacing: "1px",
    },
    otpInput: {
      width: "100%",
      padding: "14px",
      border: "1px solid #cbd5e1",
      borderRadius: "10px",
      fontSize: "18px",
      marginBottom: "24px",
      textAlign: "center",
      letterSpacing: "2px",
    },
    iconContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "32px",
      marginBottom: "24px",
    },
    icon: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
      fontWeight: "bold",
      color: "white",
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      transition: "transform 0.2s",
    },
    angelOneIcon: {
      background: "linear-gradient(135deg, #000000 0%, #333333 100%)",
    },
    googleIcon: {
      background: "linear-gradient(135deg, #4285F4 0%, #3367D6 100%)",
    },
    button: {
      width: "100%",
      padding: "14px",
      background: "linear-gradient(135deg, #9333ea 0%, #6366f1 100%)",
      color: "white",
      border: "none",
      borderRadius: "10px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      marginBottom: "16px",
      boxShadow: "0 4px 10px rgba(147, 51, 234, 0.3)",
    },
    secondaryButton: {
      width: "100%",
      padding: "12px",
      background: "white",
      color: "#6366f1",
      border: "1px solid #c7d2fe",
      borderRadius: "10px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      marginBottom: "16px",
    },
    newuser: { textAlign: "center", fontSize: "14px", color: "#64748b" },
    signupLink: {
      display: "block",
      textAlign: "center",
      color: "#6366f1",
      textDecoration: "none",
      fontWeight: "600",
      marginBottom: "20px",
    },
    terms: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "13px",
      marginBottom: "15px",
      color: "#475569",
    },
    checkbox: { marginTop: "4px" },
    status: {
      textAlign: "center",
      fontSize: "13px",
      color: "red",
      marginTop: "8px",
      fontWeight: "500",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <div style={styles.header}>
            <h1 style={styles.title}>
              Login
            </h1>
          </div>
          <div style={styles.content}>
            {/* Step 1: Phone Login */}
            {loginStep === "phone" && (
              <form onSubmit={handlePhoneLogin}>
                <input
                  type="tel"
                  placeholder="Enter 10-digit phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  style={styles.input}
                  maxLength={10}
                />

                {/* <div style={styles.iconContainer}>
                  <div
                    onClick={handleAngelLogin}
                    style={{ ...styles.icon, ...styles.angelOneIcon }}
                    onMouseDown={(e) =>
                      (e.currentTarget.style.transform = "scale(0.95)")
                    }
                    onMouseUp={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    A
                  </div>
                  <div
                    style={{ ...styles.icon, ...styles.googleIcon }}
                  >
                    G
                  </div>
                </div> */}


                {/* <label style={styles.terms}>
                  <input
                    type="checkbox"
                    checked={agreeToTerms}
                    onChange={(e) => setAgreeToTerms(e.target.checked)}
                    style={styles.checkbox}
                  />
                  I agree to the{" "}
                  <a
                    href="/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#6366f1", textDecoration: "underline" }}
                  >
                    Terms & Conditions
                  </a>
                </label> */}

                <button type="submit" style={styles.button}>
                  Login with Phone
                </button>

                {/* <p style={styles.newuser}>New User?</p>
                <a href="/signup" style={styles.signupLink}>
                  Sign Up
                </a> */}


                {status && <p style={styles.status}>{status}</p>}
              </form>
            )}

            {/* Step 2: Password */}
            {loginStep === "password" && (
              <form onSubmit={handlePasswordSubmit}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#475569",
                    marginBottom: "12px",
                  }}
                >
                  Enter password to Login
                </p>
                <input
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                  style={styles.otpInput}
                />
                <button type="submit" style={styles.button}>
                  Verify & Login
                </button>
                <button
                  type="button"
                  onClick={goBackToPhone}
                  style={styles.secondaryButton}
                >
                  ← Back
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
